import {
  Stack,
  Typography,
  LinearProgress,
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useContext, useEffect, useRef, useState } from 'react';
import mainLogo from '../../../images/black_letters_with_blue_shadow.svg';
import html2canvas from 'html2canvas';
import clipboardCopy from 'clipboard-copy';
import axios from 'axios';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link, useNavigate } from 'react-router-dom';

import DynamicProgressBar from '../../../components/progressBars/dynamicProgressBar';
import getHealthFunctions from '../helperfunctions';
import { CLIENT_TYPES } from '../../../api/clientconfig';
import { getClientConfig, getClientTypeFromOrgId, ORGANIZATION_IDS } from '../../../config/clientThemes';
import ShareButtons from '../../../components/buttons/ShareButtons';
import APIObjectsContext from '../../../context/APIObjectsContext';
import HealthCategoryNav from '../../../components/NavigationBar/HealthCategoryNavigationBar';
import { identifyClientType } from '../../../utils/identifyClientType';
/**
 * Component for user login.
 *
 * @returns {JSX.Element} - The rendered LoginPage component.
 */

export const AllHealthScore = ( { title, value, symptoms,onBackBtnClick, getCategories, handleCategorySelect, activeCategoryIndex,findProductBtnHandlerForSymptomPage  } ) => {
    const [ isFromDoktor, setIsFromDoktor ] = useState( false );
    const { userAssessmentID, setUserAssessmentID } = useContext( APIObjectsContext );
    const [ isAtplFlow, setIsAtplFlow ] = useState( ( window.localStorage.getItem( 'from_atp' ) === "true" ) ? true : false );

    const [clientType, setClientType] = useState(() => {
    const orgId = parseInt(localStorage.getItem('organization_id'));
    if (!isNaN(orgId)) {
      console.log(orgId,getClientTypeFromOrgId(orgId));
      
      return getClientTypeFromOrgId(orgId);
    }
    // If no org ID found, set default org ID and return default client type
    localStorage.setItem('organization_id', ORGANIZATION_IDS.DEFAULT.toString());
    return CLIENT_TYPES.DEFAULT;
  });
  
    // useEffect(() => {
    //   // Determine client type based on your authentication or route
    //   const determineClientType = () => {
    //     const fromDoktor = window.localStorage.getItem('from_doktor');
    //     if (fromDoktor === 'true') {
    //       return CLIENT_TYPES.DOKTOR_CONNECT;
    //     }
    //     // Add logic for ATP detection
    //     const fromATP = window.localStorage.getItem('from_atp');
    //     if (fromATP === 'true') {
    //       return CLIENT_TYPES.ATP;
    //     }
    //     return CLIENT_TYPES.DEFAULT;
    //   };
  
    //   setClientType(determineClientType());
    // }, []);

        useEffect(() => {
          setClientType(identifyClientType());
        }, []);

      useEffect( () => {
        // Check localStorage for the flag
        const fromDoktor = window.localStorage.getItem( 'from_doktor' );
        setIsFromDoktor( fromDoktor === 'true' );
      }, [] );

  const config = getClientConfig(clientType);
  let allHealthVal = Number( value );

  // Using Math.floor() to round down
  let integerallHealthVal = Math.ceil( allHealthVal );

  const [ open, setOpen ] = useState( false );

  const handleClickOpen = () => {
    setOpen( true );
  };

  const handleClose = () => {
    setOpen( false );
  };

  const [ progress, setProgress ] = React.useState( 90 );

  const [ ShadowClass, setShadowClass ] = useState( true );

  const [ cloudinaryLink, setCloudinaryLink ] = useState( '' );

  React.useEffect( () => {
    // Simulate progress change (remove if not needed)
    const timer = setTimeout( () => setProgress( Math.min( progress + 90, 90 ) ), 1000 );
    return () => clearTimeout( timer );
  }, [ progress ] );

  // const isSmallScreen = useMediaQuery( theme => theme.breakpoints.down( 'sm' ) );
   const isSmallScreen = useMediaQuery('(max-width:499px)');
  const isGalaxyFold = useMediaQuery( '(max-width:280px)' );

  // SOCIAL MEDIA SHARING LINKS INETGRATION STARTS //
  const cardRef = useRef( null );

  const captureAndUpload = async () => {
    try {
      await new Promise( resolve => setTimeout( resolve, 1000 ) ); // Add delay

      const canvas = await html2canvas( cardRef.current, {
        useCORS: true,
        scale: 2, // Increase scale for higher resolution
        logging: true, // Enable logging for debugging
        allowTaint: true, // Allow tainted canvas
      } );

      const imageDataUrl = canvas.toDataURL( 'image/png' );
      const blob = await ( await fetch( imageDataUrl ) ).blob();

      // Prepare form data
      const formData = new FormData();
      formData.append( 'file', blob );
      formData.append( 'upload_preset', 'rfjd4mz2' ); // replace with your upload preset

      // Upload to Cloudinary
      const response = await axios.post( 'https://api.cloudinary.com/v1_1/dwcovmxmf/image/upload', formData );

      return response.data.secure_url;
    } catch ( error ) {
      console.error( 'Error capturing or uploading the screenshot:', error );
      return null;
    }
  };

  const shareOnFacebook = async () => {
    // Temporarily remove the class
    setShadowClass( false );
    // Re-add the class after 3 seconds
    setTimeout( () => {
      setShadowClass( true );
    }, 3000 );

    const cloudinaryLink = await captureAndUpload();
    if ( cloudinaryLink ) {
      const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${ encodeURIComponent( cloudinaryLink ) }`;
      window.open( facebookShareUrl, '_blank' );
    } else {
      console.error( 'No image link to share.' );
    }
  };

  const shareOnTwitter = async () => {
    // Temporarily remove the class
    setShadowClass( false );
    // Re-add the class after 3 seconds
    setTimeout( () => {
      setShadowClass( true );
    }, 3000 );

    const cloudinaryLink = await captureAndUpload();
    if ( cloudinaryLink ) {
      const text = 'Check out this image!'; // Your tweet text here
      const twitterShareUrl = `https://twitter.com/intent/tweet?url=${ encodeURIComponent(
        cloudinaryLink,
      ) }&text=${ encodeURIComponent( text ) }`;
      window.open( twitterShareUrl, '_blank' );
    } else {
      console.error( 'No image link to share.' );
    }
  };

  const shareOnSnapchat = async () => {
    // Temporarily remove the class
    setShadowClass( false );
    // Re-add the class after 3 seconds
    setTimeout( () => {
      setShadowClass( true );
    }, 3000 );

    const cloudinaryLink = await captureAndUpload();

    if ( cloudinaryLink ) {
      const snapchatShareUrl = `https://www.snapchat.com/scan?attachmentUrl=${ encodeURIComponent( cloudinaryLink ) }`;
      window.open( snapchatShareUrl, '_blank' );
    } else {
      console.error( 'No image link to share.' );
    }
  };

  const shareOnWhatsApp = async () => {
    // Temporarily remove the class
    setShadowClass( false );
    // Re-add the class after 3 seconds
    setTimeout( () => {
      setShadowClass( true );
    }, 3000 );

    const cloudinaryLink = await captureAndUpload();
    if ( cloudinaryLink ) {
      const text = 'Check out this image!';
      const whatsAppShareUrl = `https://api.whatsapp.com/send?text=${ encodeURIComponent( text ) }%20${ encodeURIComponent(
        cloudinaryLink,
      ) }`;
      window.open( whatsAppShareUrl, '_blank' );
    } else {
      console.error( 'No image link to share.' );
    }
  };

  const handleCopyLinkClick = async () => {
    if ( !cloudinaryLink ) {
      const link = await captureAndUpload();
      setCloudinaryLink( link );
      clipboardCopy( link );
      alert( 'Link copied to clipboard!' );
    } else {
      clipboardCopy( cloudinaryLink );
      alert( 'Link copied to clipboard!' );
    }
  };

  const isLargeScreen = useMediaQuery( theme => theme.breakpoints.up( 'lg' ) );

  const healthFunctions = getHealthFunctions('overall health score');
  const scaledValue = healthFunctions.getValue(integerallHealthVal);
  const statusColor = healthFunctions.getColor(integerallHealthVal);
  const statusText = healthFunctions.getStatus(integerallHealthVal);
  const paramValue = healthFunctions.getScaledValue(integerallHealthVal);


  // SOCIAL MEDIA SHARING LINKS INETGRATION ENDS //

  return (
    ( isLargeScreen ?
      <Stack
        display="flex"
        flexDirection="row"
        spacing={ 1 }
        alignItems="center"
        justifyContent="center"
        sx={ { width: 1, minHeight: '380px', paddingTop: '100px' } }
        className="results-page-wrapper"
        paddingBottom={ 0 }
        position={ 'relative' }
        bottom={70}
      >
        <Stack className="result-page-card large-card"  padding={ 3 }>
          <Stack ref={ cardRef } className=" large-result-component">
            {/* Top Header Starts */ }
            {/* <Stack
              className="top-header"
              display="flex"
              alignItems="center"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Stack className="top-heading">
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="bold"
                  sx={ {
                    fontSize: isGalaxyFold ? '18px' : isSmallScreen ? '23px' : '23px',
                  } }
                >
                  Overall Health Score
                </Typography>
                <Typography
                  color="#50BA47"
                  variant="p"
                  component="p"
                  fontWeight="600"
                  sx={ {
                    fontSize: isGalaxyFold ? '15px' : isSmallScreen ? '15px' : '15px',
                  } }
                >
                  Good
                </Typography>
              </Stack>
              <Box position="relative" width="80px" height="80px" background="#fff">
                <Box position="relative" display="inline-flex">
                  <DynamicProgressBar paramValue={ integerallHealthVal } paramSize={ 80 } paramThickness={ 8 } />
                  <Typography
                    variant="h6"
                    style={ { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' } }
                    sx={ { fontWeight: 'bold' } }
                  >
                    { integerallHealthVal }
                  </Typography>
                </Box>
              </Box>
            </Stack> */}
            {/* Top Header Ends */ }

            {/* Symptom Result Compoent Starts */ }
            <Stack className={ ShadowClass ? 'result-component card-shadow' : 'result-component' } sx={{
                backgroundColor: clientType === CLIENT_TYPES.DEFAULT ? "#F7F7F7 !important" : undefined,
                minHeight : "380px !important"
            }}>
              {/* Result heading */ }
              <Stack padding={ 2 }>
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="700"
                  sx={ {
                    fontSize: isGalaxyFold ? '18px' : isSmallScreen ? '18px' : '18px',
                  } }
                >
                  Health Scan Result
                </Typography>
                <Typography
                  color="black"
                  variant="p"
                  component="p"
                  fontWeight="500"
                  sx={ {
                    mt: "5px",
                    fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '13px' : '13px',
                    lineHeight: '17px',
                  } }
                >
                  According to our symptom checker tool, your symptoms most closely match the following conditions.
                </Typography>
              </Stack>
              {/* Result heading / */ }

              { symptoms.map( ( symptom, index ) => (
                <Stack paddingLeft={ 2 } paddingRight={ 2 } marginBottom={ 2 } className="progress-item" key={ index }>
                  <Stack className="prograss-bar">
                  <Tooltip title={symptom.name} placement="top" arrow >
                    <Typography
                      color="black"
                      lineHeight="30px"
                      variant="h4"
                      component="h4"
                      fontWeight="600"
                      whiteSpace="nowrap"
                      overflow="hidden"
                      textOverflow="ellipsis"
                      sx={ {
                        fontSize: isGalaxyFold ? '17px' : isSmallScreen ? '17px' : '17px',
                      } }
                    >

                      { symptom.name }
                    </Typography>
                    </Tooltip>
                    <LinearProgress
                      variant="determinate"
                      value={ Number( Math.floor( symptom.probability ) ) }
                      sx={ {
                        height: isSmallScreen ? '6px' : '7px', // Adjust height as desired
                        borderRadius: 4,
                        '& .MuiLinearProgress-barColorPrimary': {
                          // background: isFromDoktor ?  "#0633CB" : 'linear-gradient(to right, #31A6EE 0%, #35C6C9 50.5%, #A6E177 100%) !important', // Adjust gradient colors
                          background : config?.symptomChecker.symptomCheckerBarColor ? config?.symptomChecker.symptomCheckerBarColor  : "linear-gradient(to right, #31A6EE 0%, #35C6C9 50.5%, #A6E177 100%) !important"

                        },
                      } }
                    />
                    <Typography
                      // color={isFromDoktor ? "#616161"  : "#3DA9F8"}
                      color={ config?.symptomChecker.symptomMatchTextColor ? config?.symptomChecker.symptomMatchTextColor  : "black"}

                      lineHeight="20px"
                      variant="h4"
                      component="h4"
                      fontWeight="700"
                      sx={ {
                        fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '12px' : '12px',
                      } }
                    >
                      {
                        {
                          0: 'Closest match',
                          1: 'Somewhat of a match',
                          2: 'Lowest match',
                        }[ index ]
                      }
                    </Typography>
                  </Stack>
                  <Stack>
                    <Typography
                      color="black"
                      variant="h4"
                      component="h4"
                      fontWeight="700"
                      sx={ {
                        fontSize: isGalaxyFold ? '18px' : isSmallScreen ? '18px' : '18px',
                      } }
                    >
                      { Number( Math.floor( symptom.probability ) ) }%
                    </Typography>
                  </Stack>
                </Stack>
              ) ) }

                    <Box className="result-logo" sx={ { marginBottom: '10px' } }>
                        <img src={ config.logos.main } height={ config.logos.height } className="" />
                        { clientType !== CLIENT_TYPES.DEFAULT && (
                            <Typography sx={ { fontSize: '14px' } }>
                                Your health scan was powered by
                               <img src={ mainLogo }className="custom-main-logo-for-md"/>
                            </Typography>
                          ) }
                   </Box>
            </Stack>

            {/* <Stack className="bottom-info">
              <Typography
                color="black"
                marginTop="16px"
                variant="p"
                component="p"
                fontWeight="400"
                sx={ {
                  fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '12px' : '12px',
                } }
              >
                These numbers are only estimates and are not a substitute for the judgment of a healthcare professional.
                They are intended to improve awareness and general wellness. Please see our
                <a href="/" className="custom-link-tag">
                  How it Works
                </a>
                page.
              </Typography>
            </Stack> */}
          </Stack>
          

           {/* <Stack
            display="flex"
            className="result-card-footer"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            marginTop={ 1 }
          > {
           isFromDoktor ?
          <ShareButtons cardRef={ cardRef } socialButtonsCss={config?.socialButtons}/> 
          :
          <>
            <Button onClick={ shareOnWhatsApp }>
              <img src="/socialicons/s1.png" alt="" />
            </Button>
            <Button>
              <img src="/socialicons/s2.png" alt="" />
            </Button>
            <Button onClick={ shareOnSnapchat }>
              <img src="/socialicons/s3.png" alt="" />
            </Button>
            <Button id="ModalBox" onClick={ handleClickOpen }>
              <img src="/socialicons/s4.png" alt="" />
            </Button> 
            </>
            }
            </Stack>  */}
     
        </Stack>

        <Dialog open={ open } onClose={ handleClose }>
          <DialogTitle fontSize="18px">Share With Others</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Box display="flex" justifyContent="center">
                <Button
                  onClick={ shareOnFacebook }
                  sx={ {
                    backgroundColor: 'primary.main',
                    color: 'white',
                    minWidth: '36px',
                    minHeight: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:hover': {
                      backgroundColor: 'primary.dark',
                    },
                  } }
                >
                  <FontAwesomeIcon icon={ faFacebook } />
                </Button>
                <Button
                  onClick={ shareOnTwitter }
                  sx={ {
                    marginLeft: '10px',
                    marginRight: '10px',
                    backgroundColor: '#000',
                    color: 'white',
                    minWidth: '36px',
                    minHeight: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:hover': {
                      backgroundColor: 'primary.dark',
                    },
                  } }
                >
                  <FontAwesomeIcon icon={ faTwitter } />
                </Button>

                <Button
                  onClick={ handleCopyLinkClick }
                  sx={ {
                    backgroundColor: 'gray',
                    color: 'white',
                    minWidth: '36px',
                    minHeight: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:hover': {
                      backgroundColor: 'primary.dark',
                    },
                  } }
                >
                  <FontAwesomeIcon icon={ faLink } />
                </Button>
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ handleClose } color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Stack>
      :
      <Stack
        display="flex"
        flexDirection="row"
        spacing={ 2 }
        alignItems="center"
        justifyContent="center"
        sx={ { width: 1 } }
        className="results-page-wrapper"
        paddingBottom={ 1 }

      >
        <Stack className="result-page-card" backgroundColor="white" padding={ 3 } paddingTop="1px"  >
        <Box sx={{ display : "flex",flexDirection : "row", width : "100%",alignItems : "center", justifyContent : "space-between", padding : isSmallScreen ? "2px 0px" : "4px 0px"}}>
        
                  <Stack display="flex" flexDirection="row" style={{ cursor: 'pointer' }} onClick={onBackBtnClick}>
                     {clientType !== "DOKTOR_CONNECT" &&  config?.backButton}
                  </Stack>
               
                {  (clientType == CLIENT_TYPES.DEFAULT) &&
                <Stack sx={{ display : "flex",flexDirection : "row", alignItems : "center"}}>
                <Typography      
                    sx={{
                      cursor:"pointer",
                      color:"#72D8DA",
                      variant:"p",
                      component:"p",
                      fontWeight:"600",
                      fontSize:"14px",
                      textAlign:"end",
                     }}
                     onClick={()=>{ navigate('/thank_you')}}
                     > 
                      Next
                  </Typography>
                  <ArrowForwardIcon sx={{fontSize : "16px",padding : "0px 2px 0px 4px",cursor : "pointer",color : "#72D8DA"}}/>
                  </Stack>
                }
         </Box>
          <Stack className="screenshortCard">
            {/* Top Header Starts */ }
            <Stack
              className="top-header"
              display="flex"
              alignItems="center"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Stack className="top-heading">
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="bold"
                  sx={{
                    fontSize: isGalaxyFold ? '16px' : isSmallScreen ? '18px' : '23px',
                  }}
                >
                  Overall Health Score
                </Typography>
                <Typography
                  color={statusColor}
                  variant="p"
                  component="p"
                  fontWeight="600"
                  sx={ {
                    fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '14px' : '15px',
                  } }
                >
                  {statusText}
                </Typography>
              </Stack>
              <Box
                   sx={{
                    position: 'relative',
                    width: '80px',
                    height: isSmallScreen ? "64px" : '80px',
                    background: '#fff', // Add a contrasting background color
                  }}
              
              >
               <Box position="relative" display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
              
                  <DynamicProgressBar paramValue={ paramValue } barColor={ statusColor } 
                    paramSize={isGalaxyFold ? 60 : isSmallScreen ? 50 : 70}
                    paramThickness={isGalaxyFold ? 6 : isSmallScreen ? 5: 8}/>
                    

                  <Typography
                    variant="h6"
                    style={ { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' } }
                    sx={ { fontWeight: 'bold' } }
                  >
                    { integerallHealthVal }
                  </Typography>
                </Box>
              </Box>
            </Stack>
            {/* Top Header Ends */ }

            {/* Symptom Result Compoent Starts */ }
            <Stack  
             sx={ { 
              backgroundColor: clientType === CLIENT_TYPES.DEFAULT ? "#F7F7F7 !important" : undefined,
              position: 'relative',
              minHeight : isSmallScreen && "304px !important" ,
              bottom: config?.resultPageSlider?.isResultPageSliderVisible  ? '30px' : '0px' 
                 } }
              className={ ShadowClass ? 'result-component card-shadow' : 'result-component' } 
              ref={ cardRef } 
              >
              {/* Result heading */ }
              <Stack paddingX={isSmallScreen ? 2 : 3}  paddingY={isSmallScreen ? 1 : 3}>
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="700"
                  sx={ {
                    fontSize: isGalaxyFold ? '14px' : isSmallScreen ? '16px' : '22px',
                  } }
                >
                  Health Scan Result
                </Typography>
                <Typography
                  color="black"
                  variant="p"
                  component="p"
                  fontWeight="500"
                  sx={ {
                    mt: isSmallScreen ? "2px" : 1,
                    fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '10px' : '13px',
                    lineHeight: '17px',
                  } }
                >
                  According to our symptom checker tool, your symptoms most closely match the following conditions.
                </Typography>
              </Stack>
              {/* Result heading / */ }

              { symptoms.map( ( symptom, index ) => (
                <Stack paddingLeft={ isSmallScreen ? 2 : 3 } paddingRight={ isSmallScreen ? 2 :  3 } marginBottom={ isSmallScreen ? "2px" : 2 } className="progress-item" key={ index }>
                  <Stack className="prograss-bar">
                    <Typography
                      color="black"
                      lineHeight="30px"
                      variant="h4"
                      component="h4"
                      fontWeight="600"
                      sx={ {
                        fontSize: isGalaxyFold ? '16px' : isSmallScreen ? '13px' : '17px',
                      } }
                    >
                      { symptom.name }
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={ Number( Math.floor( symptom.probability ) ) }
                      sx={ {
                        height: isSmallScreen ? '6px' : '6px', // Adjust height as desired
                        borderRadius: 4,
                        '& .MuiLinearProgress-barColorPrimary': {
                         background: config?.symptomChecker.symptomCheckerBarColor ?  config?.symptomChecker.symptomCheckerBarColor   : 'linear-gradient(to right, #31A6EE 0%, #35C6C9 50.5%, #A6E177 100%) !important', // Adjust gradient colors
                        },
                      } }
                    />
                    <Typography
                      color={ config?.symptomChecker.symptomMatchTextColor ? config?.symptomChecker.symptomMatchTextColor  : "#3DA9F8"}
                      lineHeight="20px"
                      variant="h4"
                      component="h4"
                      fontWeight="700"
                      sx={ {
                        fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '10px' : '12px',
                      } }
                    >
                      {
                        {
                          0: 'Closest match',
                          1: 'Somewhat of a match',
                          2: 'Lowest match',
                        }[ index ]
                      }
                    </Typography>
                  </Stack>
                  <Stack>
                    <Typography
                      color="black"
                      variant="h4"
                      component="h4"
                      fontWeight="700"
                      sx={ {
                        fontSize: isGalaxyFold ? '18px' : isSmallScreen ? '18px' : '23px',
                      } }
                    >
                      { Number( Math.floor( symptom.probability ) ) }%
                    </Typography>
                  </Stack>
                </Stack>
              ) ) }

               <Box className="result-logo" sx={ { marginBottom: clientType !== CLIENT_TYPES.DEFAULT && isSmallScreen ? '1px' : '18px' } }>
                   <img src={ config.logos.main } height={ config.logos.height } className="" />
                   { clientType !== CLIENT_TYPES.DEFAULT && (
                     <Typography sx={ { fontSize: isGalaxyFold ? "8px" : '10px', display: "flex", alignItems: "center", width: "100%", paddingTop: "8px", justifyContent: "center" } }>
                      Your health scan was powered by
                       <img src={ mainLogo }className="custom-main-logo" />
                     </Typography>
                  ) }
                </Box>

            </Stack>

            { config?.resultPageSlider?.isResultPageSliderVisible  && (
            <Box sx={ { position: 'relative', bottom: "30px" } }>
              <HealthCategoryNav
                categories={ getCategories }
                activeIndex={ activeCategoryIndex }
                onSelectCategory={ handleCategorySelect }
                isLargeScreen={ false }
                clientBaseNavCss={{
                  arrowColor : config?.resultPageSlider?.arrowColor,
                  arrowHOverColor : config?.resultPageSlider?.arrowHOverColor,
                  movingIndicatorColor : config?.resultPageSlider?.movingIndicatorColor
                }}
              />
            </Box> )}

            <Stack className="bottom-info">
              <Typography
                color="black"
                marginTop="16px"
                variant="p"
                component="p"
                fontWeight="400"
				sx={ {
					fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '10px' : '12px',
					position: isAtplFlow  || config?.resultPageSlider?.isResultPageSliderVisible  ? 'relative' : null, bottom: isAtplFlow || config?.resultPageSlider?.isResultPageSliderVisible  ? '40px' : '0px'
				  } }
              >
                These numbers are only estimates and are not a substitute for the judgment of a healthcare professional.
                They are intended to improve awareness and general wellness. Please see our
                <a href="/" className="custom-link-tag">
                  How it Works
                </a>
                page.
              </Typography>
            </Stack>
          </Stack>

          {/* Footer Starts */ }
         {/* { isFromDoktor || clientType === "ATP" ? <Stack
            display="flex"
            className="result-card-footer"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            marginTop={ isSmallScreen ? "4px" : 1 }
            marginBottom={ clientType === "ATP" && "24px"}
          >
            <ShareButtons cardRef={ cardRef } socialButtonsCss={config?.socialButtons}/>
          </Stack> :
           <Stack
            display="flex"
            className="result-card-footer"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            marginTop={ isSmallScreen ? "4px" : 1 }
          >
           <ShareButtons cardRef={ cardRef } item={ {userAssessmentID : userAssessmentID}} socialButtonsCss={config?.socialButtons} />
          </Stack>
            } */}

                  <Box marginTop='20px' sx={{position: config?.resultPageSlider?.isResultPageSliderVisible ? 'relative' : null, bottom: config?.resultPageSlider?.isResultPageSliderVisible ? '50px' : '0px'}}>
                    {(clientType === "ATP" || clientType === "HELLO_HEALTH") &&
				
                        <Button
						                onClick={findProductBtnHandlerForSymptomPage}
                            fullWidth
                            className={ 'btn-shadow' }
                            sx={ {
                                      height: isSmallScreen ? '50px' : '60px',
                                      borderRadius: isFromDoktor || isAtplFlow || (clientType === "HELLO_HEALTH") ? '10px' : '40px',
                                      marginBottom: isSmallScreen ? '6px' : '10px',
                                      background: config.button.background,
                                      maxWidth: '400px',
                                      textAlign: 'center',
                                      color: "#fff",
                                      "&:hover": {
                                        color: "black"
            
                                      },
                                    } }
                             >
            
                              <Typography
                                      className="btn-txt"
                                      variant="p"
                                      component="p"
                                      fontWeight="600"
                               
                                      sx={ {
                                        fontSize: isSmallScreen ? '16px' : '20px',
                                      } }
                                    >
                                      👀 Find Products That Can Help
                                </Typography>
                         </Button>
                 
                    }
				{ isFromDoktor || clientType === "ATP" || clientType === "HELLO_HEALTH" ? 
				<Stack
                      display="flex"
                      className="result-card-footer"
                      flexDirection="row"
                      justifyContent="center"
                      alignItems="center"
                      marginTop={ isSmallScreen ? "4px" : 1 }
                      marginBottom={ clientType === "ATP" && "24px"}
                  
				  >
                    <ShareButtons cardRef={ cardRef } socialButtonsCss={config?.socialButtons}/>
                </Stack> :
                <Stack
                    display="flex"
                    className="result-card-footer"
                    flexDirection="row"
                    justifyContent="center"
                    alignItems="center"
                    marginTop={ isSmallScreen ? "4px" : 1 }
                   >
                   <ShareButtons cardRef={ cardRef } item={ {userAssessmentID : userAssessmentID}} socialButtonsCss={config?.socialButtons} />
                </Stack>
                }
					
                       
                     
                  </Box>

          {/* Footer Ends */ }
        </Stack>

        <Dialog open={ open } onClose={ handleClose }>
          <DialogTitle fontSize="18px">Share With Others</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Box display="flex" justifyContent="center">
                <Button
                  onClick={ shareOnFacebook }
                  sx={ {
                    backgroundColor: 'primary.main',
                    color: 'white',
                    minWidth: '36px',
                    minHeight: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:hover': {
                      backgroundColor: 'primary.dark',
                    },
                  } }
                >
                  <FontAwesomeIcon icon={ faFacebook } />
                </Button>
                <Button
                  onClick={ shareOnTwitter }
                  sx={ {
                    marginLeft: '10px',
                    marginRight: '10px',
                    backgroundColor: '#000',
                    color: 'white',
                    minWidth: '36px',
                    minHeight: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:hover': {
                      backgroundColor: 'primary.dark',
                    },
                  } }
                >
                  <FontAwesomeIcon icon={ faTwitter } />
                </Button>

                <Button
                  onClick={ handleCopyLinkClick }
                  sx={ {
                    backgroundColor: 'gray',
                    color: 'white',
                    minWidth: '36px',
                    minHeight: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:hover': {
                      backgroundColor: 'primary.dark',
                    },
                  } }
                >
                  <FontAwesomeIcon icon={ faLink } />
                </Button>
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ handleClose } color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Stack>
    )
  )
};
